export enum ACTIONS {
  SET_AUTHENTICATED = "SET_AUTHENTICATED",
}

export interface IStatePayload {
  authenticated: boolean;
}

export type Actions<T> = { type: ACTIONS; payload: T };
